import React, { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { createRoot } from 'react-dom/client';
import ModalInfo from './ModalInfo';
import ModalInfoKiosk from './ModalInfoKiosk';
import ModalErrorLicenceplateUnknown from './ModalErrorLicenceplateUnknown';
import ModalHowToDetermineSize from './ModalHowToDetermineSize';
import ModalHowToPump from "./ModalHowToPump";
import ModalInfoIdentifySize from "./ModalInfoIdentifySize";
import ModalResultsMore from "./ModalResultsMore";
import './modal.scss';

const Modal = forwardRef((props, ref) => {
	//console.log('modal', props);
	const [hidden, setHidden] = useState(true);
	const contentRef = useRef(null);
	const rootRef = useRef(null);

	const getOrCreateRoot = () => {
		if (!rootRef.current && contentRef.current) {
			rootRef.current = createRoot(contentRef.current);
		}
		return rootRef.current;
	};

	const show = (modalId) => {
		const root = getOrCreateRoot();
		switch(modalId) {
			case('info'):
				if (props.isKioskMode) root.render(<ModalInfoKiosk />);
				else root.render(<ModalInfo />);
			break;
			case ('error-licenceplate-unknown'):
				root.render(<ModalErrorLicenceplateUnknown hide={hide} />);
			break;
			case ('how-to-pump'):
				root.render(<ModalHowToPump />);
			break;
			case ('info-identify-size'):
				root.render(<ModalInfoIdentifySize />);
				break;
			case ('how-to-determine-size'):
				root.render(<ModalHowToDetermineSize />);
			break;
			case ('results-more'):
				root.render(<ModalResultsMore />);
				break;
			default:
			break;
		}

		setHidden(false);

		window.document.addEventListener('keyup', (event) => {
			if (event.defaultPrevented) {
				return;
			}
			var key = event.key || event.keyCode;
			if (key === 'Escape' || key === 'Esc' || key === 27) {
				hide();
			}
		});
	}

	const hide = () => {
		setHidden(true);
	}

	const onRootnodeClick = (e) => {
		if (!e.target.classList.contains('modal-cont')) {
			return false;
		}
		hide();
	};

	const onCloseButtonClick = (e) => {
		hide();
	};

	useImperativeHandle(ref, () => {
		return {
			show: show,
			hide: hide
		};
	});

	return (
		<React.Fragment>
		<div className={"modal-cont " + (hidden ? 'hidden' : '')} onClick={onRootnodeClick}>
			<div className="modal">
				<div className="btn-close" role="button" onClick={onCloseButtonClick}></div>
				<div className="content" ref={contentRef}>
					{}
				</div>
			</div>
		</div>
		</React.Fragment>
	)
});

export default Modal;
